import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RirekishoHistoryItem } from '@src/api/core/api-types';

const initialState: RirekishoHistoryItem[] = [];

const rirekishoHistorySlice = createSlice({
  name: 'rirekishoHistory',
  initialState,
  reducers: {
    updateRirekishoHistory(_state, action: PayloadAction<RirekishoHistoryItem[]>) {
      return action.payload;
    },
    addRirekishoHistoryItem(state, action: PayloadAction<RirekishoHistoryItem>) {
      state.push(action.payload);
    },
    updateRirekishoHistoryItem(
      state,
      action: PayloadAction<{ index: number; item: Partial<RirekishoHistoryItem> }>
    ) {
      const { index, item } = action.payload;
      if (state[index]) {
        state[index] = { ...state[index], ...item };
      }
    },
    removeRirekishoHistoryItem(state, action: PayloadAction<number>) {
      state.splice(action.payload, 1);
    },
  },
});

export const {
  updateRirekishoHistory,
  addRirekishoHistoryItem,
  updateRirekishoHistoryItem,
  removeRirekishoHistoryItem,
} = rirekishoHistorySlice.actions;

export default rirekishoHistorySlice.reducer;
